/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { spacing, ticketColors, typography } from '../theme/public-api';
import { ticketChrome } from './ticketChrome.styles';

type Props = {
  /** Kicker uppercase teal (ej. "Catálogo"). */
  kicker?: string;
  title: string;
  subtitle?: string;
  onClose: () => void;
  /** Deshabilita el botón X (ej. guard de cambios sin guardar). */
  closeDisabled?: boolean;
  /** Padding lateral compacto (sheets mobile / cards angostas). */
  compact?: boolean;
  /** Sin borde inferior (card chica donde el body ya separa). */
  borderless?: boolean;
};

/** Header de modal nuevo estilo: kicker teal + título grande + subtítulo + X. */
export function TicketModalHeader({
  kicker,
  title,
  subtitle,
  onClose,
  closeDisabled = false,
  compact = false,
  borderless = false,
}: Props) {
  return (
    <View
      style={[
        styles.head,
        compact ? styles.headCompact : styles.headWide,
        borderless && styles.headBorderless,
      ]}
    >
      <View style={styles.titleBlock}>
        {kicker ? <Text style={styles.kicker}>{kicker}</Text> : null}
        <Text style={styles.title} accessibilityRole="header">
          {title}
        </Text>
        {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
      </View>
      <TouchableOpacity
        onPress={onClose}
        disabled={closeDisabled}
        style={ticketChrome.sheetCloseBtn}
        accessibilityRole="button"
        accessibilityLabel="Cerrar"
      >
        <Text style={ticketChrome.sheetCloseGlyph}>×</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  head: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },
  headWide: {
    paddingHorizontal: 20,
    paddingTop: 18,
    paddingBottom: 16,
  },
  headCompact: {
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 12,
  },
  headBorderless: {
    borderBottomWidth: 0,
  },
  titleBlock: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },
  kicker: {
    fontSize: 10,
    lineHeight: 14,
    fontWeight: '800',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: ticketColors.brandPrimary,
  },
  title: {
    ...typography.titleLg,
    color: ticketColors.ink,
  },
  subtitle: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
});
